// import React from 'react'

// const VideosBanner = () => {
//   return (
//     <div className='videos-main-container'>
//       <div className='container'>

//       </div>
//     </div>
//   )
// }

// export default VideosBanner
import React, { useEffect, useState } from 'react';
import VideosImage from '../../assets/images/videos/image.jpg';


const VideosBanner = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const thumbnails = [
    {
      url: 'https://www.youtube.com/embed/e1lT6-iGNG0?autoplay=1&rel=0',
      thumb: 'https://img.youtube.com/vi/e1lT6-iGNG0/0.jpg',
    },
    {
      url: 'https://www.youtube.com/embed/n5HxElr2pa0?autoplay=1&rel=0',
      thumb: 'https://img.youtube.com/vi/n5HxElr2pa0/0.jpg',
    },
  ];

  const handlePlayClick = () => {
    setVideoUrl(thumbnails[0].url);
    setIsPlaying(true);
  };

  const handleThumbnailClick = (url) => {
    setVideoUrl(url);
    setIsPlaying(true);
  };

  return (
    <div className='videos-main-container'>
      <div className='container'>
        <div className='videos-content' id='sec02'>
          <div className='video-image-container'>
            {isPlaying ? (
              <iframe
                className='fromCenter'
                src={videoUrl}
                width='100%'
                height='100vh'
                title='Parent Firm Video'
                allow='autoplay; encrypted-media'
                allowFullScreen
              />
            ) : (
              <img
                className='fromCenter'
                src={VideosImage}
                alt='Parent Firm Image'
              />
            )}
            {!isPlaying && (
              <div className='play-icon' onClick={handlePlayClick}>
                <svg width='40' height='40' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M8 5v14l11-7z' />
                </svg>
              </div>
            )}
          </div>
          <div className='thumbnail-section'>
            {thumbnails.map((thumb, index) => (
              <button key={index} onClick={() => handleThumbnailClick(thumb.url)}>
                <img src={thumb.thumb} alt={`Thumbnail ${index + 1}`} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideosBanner;
